
import Vue from 'vue'

import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'CarouselStandard',
  mixins: [staticBlockMixin],
  data () {
    return {
      bannerBlock: {},
      isMounted: false,
      splideOptions: {
        perPage: 1,
        gap: 20
      }
    }
  },
  async fetch () {
    try {
      this.bannerBlock = await this.$banners.getBannerBlockByCode(this.mainFields?.code?.value)
    } catch (e: any) {
      console.error(e)
    }
  },
  mounted () {
    this.isMounted = true
  }
})
